import React, { Component } from "react";
import { Spin, Card, Divider, Popover } from "antd";
import QRCode from "qrcode.react";
import { app, config } from "../app";
import PropTypes from "prop-types";
import newsHead from "../assets/news-head.png";
import newsBottom from "../assets/news-bottom.png";
import "braft-editor/dist/output.css";

class NewsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  render() {
    let { loading, data, review } = this.props;
    return loading ? (
      <div style={{ textAlign: "center" }}>
        <Spin size="large" />
      </div>
    ) : (
      <div style={{ padding: "0 20px" }}>
        <div style={{ maxWidth: 1190, margin: "0 auto", padding: "20px 0" }}>
          <div
            className="braft-output-content"
            dangerouslySetInnerHTML={{ __html: data.content }}
            style={{ padding: "20px 0" }}
          />
        </div>
      </div>
    );
  }
}

NewsDetail.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.any,
};

export default NewsDetail;



// WEBPACK FOOTER //
// ./src/components/Rule.jsx